import React, { useState, useContext } from 'react';
import AuthContext from '../../../context/AuthContext';
import SlotRequestForm from './SlotRequestForm';
import './RequestSlotButton.css';

const RequestSlotButton = ({ 
  interviewerId, 
  interviewerName = 'an interviewer', 
  interviewType = 'interview',
  variant = 'outline-primary'
}) => {
  const [showModal, setShowModal] = useState(false);
  const { user } = useContext(AuthContext);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleSuccess = () => {
    handleClose();
    // You might want to show a success message here
    if (window.M) {
      window.M.toast({ html: 'Slot request submitted successfully!' });
    }
  };

  // Only render if we have a valid interviewerId
  if (!interviewerId) {
    console.warn('RequestSlotButton: No interviewerId provided');
    return null;
  }

  return (
    <>
      <button 
        className={`btn btn-${variant}`} 
        onClick={handleShow}
      >
        Request Custom Slot
      </button>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Request a Slot with {interviewerName}</h5>
                <button type="button" className="close" onClick={handleClose}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <SlotRequestForm 
                  interviewerId={interviewerId}
                  onSuccess={handleSuccess}
                  onCancel={handleClose}
                  defaultInterviewType={interviewType}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RequestSlotButton;
